import { AxiosError, isAxiosError } from 'axios'

export class AxiosInternalServerError extends AxiosError {
  constructor() {
    super(...arguments)
    this.status === 500
  }

  static [Symbol.hasInstance](instance) {
    if (!isAxiosError(instance)) return false
    return instance.status === 500
  }
}